import { render, staticRenderFns } from "./TestmodeBadge.vue?vue&type=template&id=a22624b4"
import script from "./TestmodeBadge.vue?vue&type=script&lang=js"
export * from "./TestmodeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports